import { memo } from 'react';

import type { FunctionComponent } from 'react';
import type { TypeDateTimeProps } from './types';

/**
 * DateTime
 */
export const DateTime: FunctionComponent<TypeDateTimeProps> = memo(
  ({ className = '', time, type }: TypeDateTimeProps) => (
    <div className={`flex flex-row ${className}`}>
      <span className="inline-block">{time}</span>
      {type}
    </div>
  )
);

DateTime.displayName = 'DateTime';
